module.exports = require("@vscode-alt/monaco-editor/esm/vs/platform/keybinding/common/usLayoutResolvedKeybinding");